export default "__VITE_ASSET__89a23bf1__"